import AgoraRTC, { ILocalAudioTrack, ILocalTrack, ILocalVideoTrack, ScreenVideoTrackInitConfig } from "agora-rtc-sdk-ng"
import AgoraManager from "./AgoraManager"

class AgoraScreenManager extends AgoraManager 
{
    /**
     * Screen track. This can handle computer's audio
     * 
     * TODO: Support share screen audio
     */
    tracks: ILocalVideoTrack | [ILocalVideoTrack, ILocalAudioTrack] | undefined
    
    async initialize(config: ScreenVideoTrackInitConfig)
    {
        if(!this.client)
            super.initializeClient()
        this.tracks = await AgoraRTC.createScreenVideoTrack(config)
        return this.tracks
    }

    /**
     * Leave the room and destroy the localTracks
     */
    async destroy()
    {
        await this.client?.leave()
        if(this.tracks)
        {
            if(Array.isArray(this.tracks))
            {
                this.tracks.forEach(track => AgoraManager.destroyTrack(track))
            }
            else if(typeof this.tracks === "object")
            {
                AgoraManager.destroyTrack((this.tracks as ILocalTrack))
            }
            this.tracks = undefined
        }

        this.client = undefined
    }

    /**
     * Since this class might be able to handle local Video Track and local Audio Tracks,
     * this function will ensure that when calling `tracks`, only the localVideoTrack 
     * will be retrieved, instead of a very likely array
     * @returns 
     */
    getLocalVideoTrack(): ILocalVideoTrack | undefined
    {
        if(Array.isArray(this.tracks))
        {
            return this.tracks[0]
        }
        else
        {
            return this.tracks
        }
    }
}

export default AgoraScreenManager
